import { merge } from "lodash"
import { makeDefaultMaterialRoute } from "@common/router/utils"

import DocumentListWrapper from "@wrappers/DocumentListWrapper.vue"
import DocumentPageWrapper from "@wrappers/DocumentPageWrapper.vue"

export default function(material, { highlight = false, isPublic = false } = {}) {
  return merge({}, makeDefaultMaterialRoute(material), {
    path: "kko",
    children: [
      {
        path: "",
        name: "supremeCourtPrecedent.index",
        component: DocumentListWrapper,
        meta: {
          title: "heading.supremeCourtPrecedent.index",
          isPublic: !!isPublic,
        },
        hidden: false,
      },
      {
        path: ":documentKey(\\d+)/:documentLanguage(en|fi|sv)?",
        name: "supremeCourtPrecedent.documentView",
        component: DocumentPageWrapper,
        meta: {
          validateDocumentLanguage: true,
          isPublic: !!isPublic,
        },
        hidden: true, // Do not show in Nav
      },
    ],
    highlightItem: highlight,
  })
}
